<div *ngIf="deviceParamGatewayV3 ">

<mat-vertical-stepper #stepper *ngIf="editable">
<mat-step>
<ng-template matStepLabel>Main</ng-template>
<app-param-main [deviceParamGatewayV3]="deviceParamGatewayV3"></app-param-main>
</mat-step>
<mat-step>
<ng-template matStepLabel>Networks</ng-template>
<app-param-networks [deviceParamGatewayV3Network]="deviceParamGatewayV3.networks"></app-param-networks>
</mat-step>
<mat-step>
<ng-template matStepLabel>{{'CRON'|translate}}</ng-template>
<app-param-cron [deviceParamGatewayV3Cron]="deviceParamGatewayV3.cron"></app-param-cron>
</mat-step>
<mat-step>
<ng-template matStepLabel>{{'SERVER'|translate}}</ng-template>
<app-param-server [deviceParamGatewayV3Server]="deviceParamGatewayV3.server"></app-param-server>
</mat-step>
<mat-step>
<ng-template matStepLabel>{{'OSMOS_LIRIS_MANAGER'|translate}}</ng-template>
<app-param-osmos-liris-manager
                [deviceParamGatewayV3OsmosLirisManager]="deviceParamGatewayV3.osmos_liris_manager"></app-param-osmos-liris-manager>
    </mat-step>
</mat-vertical-stepper>

<div *ngIf="!editable">

    <h4 *ngIf="deviceParamGatewayV3">Main</h4>
    <app-param-main [deviceParamGatewayV3]="deviceParamGatewayV3"
                    [editable]="false"></app-param-main>

    <h4>Networks</h4>
    <app-param-networks *ngIf="deviceParamGatewayV3.networks" [deviceParamGatewayV3Network]="deviceParamGatewayV3.networks"
                        [editable]="false"></app-param-networks>

    <h4 *ngIf="deviceParamGatewayV3.cron">{{'CRON'|translate}}</h4>
    <app-param-cron *ngIf="deviceParamGatewayV3.cron" [deviceParamGatewayV3Cron]="deviceParamGatewayV3.cron"
                    [editable]="false"></app-param-cron>

    <h4 *ngIf="deviceParamGatewayV3.server">{{'SERVER'|translate}}</h4>
    <app-param-server *ngIf="deviceParamGatewayV3.server" [deviceParamGatewayV3Server]="deviceParamGatewayV3.server"
                      [editable]="false"></app-param-server>

    <h4 *ngIf="deviceParamGatewayV3.osmos_liris_manager">{{'OSMOS_LIRIS_MANAGER'|translate}}</h4>
    <app-param-osmos-liris-manager *ngIf="deviceParamGatewayV3.osmos_liris_manager"
                                   [deviceParamGatewayV3OsmosLirisManager]="deviceParamGatewayV3.osmos_liris_manager"
                                   [editable]="false"></app-param-osmos-liris-manager>

</div>
<br clear="both"/>

</div>
